/**
 * Native replacements for the lodash utility functions previously used in this codebase.
 * All functions keep the same name and signature as their lodash counterparts.
 */
/**
 * Checks whether a value is empty.
 * Returns true for: null, undefined, empty arrays, empty strings, empty objects.
 * Returns true for non-collection primitives (numbers, booleans) matching lodash behaviour.
 */
export function isEmpty(value) {
    if (value == null)
        return true;
    if (Array.isArray(value))
        return value.length === 0;
    if (typeof value === "string")
        return value.length === 0;
    if (value instanceof Map || value instanceof Set)
        return value.size === 0;
    if (typeof value === "object")
        return Object.keys(value).length === 0;
    return true;
}
/**
 * Returns a new array with duplicate values removed (using SameValueZero equality).
 */
export function uniq(arr) {
    return [...new Set(arr)];
}
/**
 * Returns a new array with duplicates removed, comparing by the value returned by the iteratee.
 * Keeps the first occurrence of each unique value.
 */
export function uniqBy(arr, iteratee) {
    const seen = new Set();
    return arr.filter((item) => {
        const key = typeof iteratee === "function" ? iteratee(item) : item[iteratee];
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
/**
 * Returns a new array sorted in ascending order by the value returned by the iteratee.
 * Does not mutate the original array.
 */
export function sortBy(collection, iteratee) {
    return [...collection].sort((a, b) => {
        const fa = iteratee(a);
        const fb = iteratee(b);
        return fa < fb ? -1 : fa > fb ? 1 : 0;
    });
}
